import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { message, Space } from "antd";
import InterfaceTable from "../../Table/InterfaceTable";
import {
  DeleteIcon,
  ModalDeleteConfirm,
  EyeOutlinedIcon,
} from "../../Utils/UI/Text";
import {
  getProjectImages,
  deleteFileImage,
} from "../Application/Projects.business";
import {
  getImagesSelector,
  getCountImagesSelector,
} from "../Infrastructure/Projects.reducer";

const ProjectImages = () => {
  const { id } = useParams();
  const images = useSelector(getImagesSelector);
  const totalImages = useSelector(getCountImagesSelector);

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    page: 0,
    limit: 5,
  });
  const [typeFilters, setTypeFilters] = useState([]);
  const fetchImages = async (customParams = {}) => {
    setLoading(true);
    try {
      const params = {
        page: values.page,
        limit: values.limit,
        ...customParams,
      };
      if (typeFilters.length > 0) {
        params.filter = {
          type: typeFilters,
        };
      }
      console.log("cargando imágenes con params:", params);
      await getProjectImages(id, params);
    } catch (error) {
      console.error("error:", error);
      message.error("Error al cargar imágenes del proyecto");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchImages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (id) {
      fetchImages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeFilters, values.page, values.limit]);

  const reloadImages = async () => {
    await fetchImages();
  };

  useEffect(() => {
    window.reloadProjectImages = reloadImages;
    return () => {
      delete window.reloadProjectImages;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, values, typeFilters]);

  const handleDelete = async (imageId) => {
    if (!imageId) {
      message.error("Esta imagen no tiene ID, no se puede eliminar");
      return;
    }

    try {
      ModalDeleteConfirm({
        title: "¿Está seguro de eliminar esta imagen del proyecto?",
        messageOnOk: "Se eliminó la imagen del proyecto correctamente.",
        onConfirm: async () => {
          setLoading(true);
          try {
            await deleteFileImage(id, imageId);
            message.success("Imagen eliminada correctamente");
            await fetchImages();
          } catch (error) {
            message.error("Error al eliminar la imagen");
          } finally {
            setLoading(false);
          }
        },
        onCancel: () => {},
      });
    } catch (error) {
      message.error("Se produjo un error, vuelva a intentarlo.");
    }
  };

  const columnsImages = [
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      filters: [
        { text: "Imagen principal del proyecto", value: "main_image_project" },
        { text: "Primera imagen de sensores", value: "first_image_sensors" },
        { text: "Segunda imagen de sensores", value: "second_image_sensors" },
        { text: "Tercera imagen de sensores", value: "third_image_sensors" },
        { text: "Imagen de galería", value: "gallery_image" },
      ],
      filteredValue: typeFilters || null,
      onFilter: () => true, 
      render: (type) => {
        const typeLabels = {
          main_image_project: "Imagen principal del proyecto",
          first_image_sensors: "Primera imagen de sensores",
          second_image_sensors: "Segunda imagen de sensores",
          third_image_sensors: "Tercera imagen de sensores",
          gallery_image: "Imagen de galería",
        };
        return typeLabels[type] || type;
      },
    },
    {
      title: "Acciones",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <Space size="middle">
          {record.url ? (
            <a href={record.url} target="_blank" rel="noopener noreferrer">
              <EyeOutlinedIcon TooltipEyeOutlined="Ver Imagen" />
            </a>
          ) : (
            <span style={{ color: "#ccc" }}>Sin imagen</span>
          )}

          {record.id ? (
            <DeleteIcon
              TooltipDelete="Eliminar imagen"
              onClick={() => handleDelete(record.id)}
            />
          ) : (
            <DeleteIcon
              TooltipDelete="Sin ID"
              disabled
              style={{ opacity: 0.3, cursor: "not-allowed" }}
            />
          )}
        </Space>
      ),
    },
  ];

  const handleRequest = (pagination = {}, antFilters = {}) => {
    const { current = 1, pageSize = values.limit } = pagination;
    const updatedValues = {
      page: current - 1,
      limit: pageSize,
    };

    setValues(updatedValues);
    const selectedTypes = antFilters.type || [];
    setTypeFilters(selectedTypes);
  };

  return (
    <div>
      <InterfaceTable
        rowKey="id"
        data={images} 
        columns={columnsImages}
        loading={loading}
        onChange={handleRequest}
        pagination={{
          current: values.page + 1,
          pageSize: values.limit,
          total: totalImages, 
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50", "100"],
        }}
      />
    </div>
  );
};

export default ProjectImages;